<template>
    <contentCardIndex >
        <template slot="cardContent">
                <v-row align="center">
                    <v-col cols="12" md="3" lg="3" class="mx-0 px-0">
                        <alternativeDatePickerRangeVCalendar
                            :valueInput="{start: dateRange.start_date, end: dateRange.end_date}"
                            @valueChange="(v) => {dateRange.start_date = v.start; dateRange.end_date = v.end; index();}"
                            label="Periodo"
                            data-cy="date-input"
                        ></alternativeDatePickerRangeVCalendar>
						
                        
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col  cols="12" md="3" lg="3" xl="2" class="mx-0 ">
                        <v-row justify="end">
                            <iconButton
                                class="mr-2 flip"
                                data-cy="export-btn"
                                :props="{
                                    iconClass: 'grey--text text--darken-3',
                                    color:'primary',
                                    icon:'mdi-progress-download',
                                    height:'36',
									loading:exportLoading,
                                    click: () => {this.export()}
                                }"
                            ></iconButton>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="mt-md-0">
                    <v-col class="mx-0 px-0">
                        <datatable data-cy="index-table" :props="tableProps" @methodHandler="method_handler">
                            <template v-slot:item.date="props">
                                <span >{{getformatDate(props.item.date)}}</span>
                            </template>
                        </datatable>
                    </v-col>
                </v-row>

                
        </template>

        
    
    </contentCardIndex>

        
</template>
<script>
import Utils from "../../../helpers/Utils";
export default {
    data(){
		return {
            ut: new Utils(),
			search: '',
            selectedID: '',
			exportLoading:false,
			dateRange: {
                start_date: Utils.getStartDate(), 
                end_date: new Date().toISOString().split('T')[0]
            },
			
			tableProps: {
				headers: [
                     {
						text: 'No. Req',
						align: 'left break-words',
						value: 'requisition_id',
						class: 'table-b-border black--text'
					},
					{
						text: 'Estatus',
						align: 'center',
						value: 'status',
						
						class: 'table-b-border black--text'
					},
                    {
						text: 'Fecha',
						align: 'center',
						value: 'date',
						
						class: 'table-b-border black--text'
					},
                    {
						text: 'Solicitante',
						align: 'center',
						value: 'requester_id',
						
						class: 'table-b-border black--text'
					},
                   
                    {
						text: 'Insumo',
						align: 'center',
						value: 'supply',
						
						class: 'table-b-border black--text'
					},

                    {
						text: 'Est partida',
						align: 'center',
						value: 'status_supply',
						
						class: 'table-b-border black--text'
					},

					{
						text: 'O.C.',
						align: 'center',
						value: 'oc',

						class: 'table-b-border black--text'
					},

                 
				],
				items: [],
				search: '',
				loading: false,
                sortBy:"sku",
                sortDesc: true,
                
			},
            
           
			
            exportBtnData: {
                text: "Exportar",
                icon: "mdi-plus",
				to: "",
				block: false,
                click: ()=>{this.export()}
            },

			
		}
	},
    computed: {
       
    },

	mounted(){
		this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        onResize () {
            
            // if(window.innerWidth < 960){
            //     this.exportBtnData.block = true;
                
            // }
            // else{
            //     this.exportBtnData.block = false;
                
            // }
        },
		getformatDate(value)
		{
			return Utils.globalDateFormat(value);
		},
        
        trySearch(val){
            this.tableProps.search = val;
        },
		index() {
			this.tableProps.loading = true;
  
			// call api
			this.$api.report.reportRequisitions(this.dateRange.start_date, this.dateRange.end_date)
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.map((x,i) => {

						x['parameters'] = { id: x.requisition_id, name: x.requisition_id, index: i};


						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

		export()
        {
            this.exportLoading = true;
            this.$store.state.loading = true;
            this.$api.report.exportRequisitions(this.dateRange.start_date, this.dateRange.end_date)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `requisitions_${this.dateRange.start_date}_${this.dateRange.end_date}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportLoading = false;
                    this.$store.state.loading = false;
                })
            ;
        },


    }
}
</script>


<style lang="scss">
    .activity-table table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .activity-table table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row){
        border-bottom: 2px solid rgba(0, 0, 0, 0.7) !important;
    }


    .disabled-box{
        height: 20px;
        width: 20px;
        border: 2px solid darkgray;
        border-radius: 5px;
        background-color: lightgray;
        margin-left: 2px;
    }


    .center-table-item{
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>